import PropTypes from 'prop-types';
import React from 'react';
import style from './BidAskContextMenu.module.css';

import {
  Menu,
  Item,
  Separator,
  Submenu,
  theme,
  animation,
} from 'react-contexify';

import 'react-contexify/dist/ReactContexify.css';
import { observer } from 'mobx-react-lite';
import { closePctPosition } from '../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/closePctPosition';
import { useWebsocketStore } from '../../../../../../stores/websocketStore/websocketProvider';
import { addPositionBreakPriceFromChart } from '../../../../../../stores/websocketStore/utils/outgoingMessages/tradePlan/updateTradePlanMessages/addPositionBreakPriceFromChart';

export const BidAskContextMenu = observer(({ scaleY, tradePlanId }) => {
  const { tradePlanStore } = useWebsocketStore();
  const tradePlan = tradePlanStore.tradePlans[tradePlanId] ?? null;
  const position = tradePlanStore.positions.tradeUnafraid[tradePlan?.positionId] ?? null;
  const inPosition = tradePlan?.inPosition;
  const id = tradePlan?.id;
  const totalTradePlanQty = position?.entryQuantity ?? null;
  const positionSymbol = tradePlan?.positionSymbol;

  function addTarget({ props, data }) {
    const price = scaleY.invert(props.yCoordinate);
    closePctPosition(id, data, positionSymbol, price, false);
  }
  function addTargetAndReplace({ props, data }) {
    const price = scaleY.invert(props.yCoordinate);
    closePctPosition(id, data, positionSymbol, price, true);
  }
  function addStop({ props }) {
    const price = scaleY.invert(props.yCoordinate);
    addPositionBreakPriceFromChart(id, price, positionSymbol);
  }

  // function addOptionStop({ props }) {
  //   const price = scaleY.invert(props.yCoordinate);
  //   addPositionBreakPriceFromChart(id, price, positionSymbol);
  // }

  if (!inPosition)
    return (
      <Menu
        id={tradePlanId + 'bidAskChart'}
        theme={theme.dark}
        animation={animation.flip}
        className={style.menu}
      >
        <Item disabled> Add </Item>
        <Separator />
      </Menu>
    );
  if (tradePlan.instrument === 'option')
    return (
      <Menu
        id={tradePlanId + 'bidAskChart'}
        theme={theme.dark}
        animation={animation.flip}
        className={style.menu}
      >
        <Item disabled> Add </Item>
        <Separator />
        <Submenu label="Target">
          <Item data={0.1} onClick={addTarget}>{`10%[${Math.ceil(
            totalTradePlanQty * 0.1
          )}]`}</Item>
          <Item data={0.25} onClick={addTarget}>{`25%[${Math.ceil(
            totalTradePlanQty * 0.25
          )}]`}</Item>
          <Item data={0.5} onClick={addTarget}>{`50%[${Math.ceil(
            totalTradePlanQty * 0.5
          )}]`}</Item>
          <Item data={0.75} onClick={addTarget}>{`75%[${Math.ceil(
            totalTradePlanQty * 0.75
          )}]`}</Item>
        </Submenu>
        <Submenu label="Target + Replace">
          <Item data={0.1} onClick={addTargetAndReplace}>{`10%[${Math.ceil(
            totalTradePlanQty * 0.1
          )}]`}</Item>
          <Item data={0.25} onClick={addTargetAndReplace}>{`25%[${Math.ceil(
            totalTradePlanQty * 0.25
          )}]`}</Item>
          <Item data={0.5} onClick={addTargetAndReplace}>{`50%[${Math.ceil(
            totalTradePlanQty * 0.5
          )}]`}</Item>
          <Item data={0.75} onClick={addTargetAndReplace}>{`75%[${Math.ceil(
            totalTradePlanQty * 0.75
          )}]`}</Item>
        </Submenu>
        <Item onClick={addStop}>Stop</Item>
      </Menu>
    );

  return (
    <Menu
      id={tradePlanId + 'bidAskChart'}
      theme={theme.dark}
      animation={animation.flip}
      className={style.menu}
    >
      <Item disabled> Add </Item>
      <Separator />
      <Submenu label="Target">
        <Item data={0.1} onClick={addTarget}>{`10%[${Math.ceil(
          totalTradePlanQty * 0.1
        )}]`}</Item>
        <Item data={0.25} onClick={addTarget}>{`25%[${Math.ceil(
          totalTradePlanQty * 0.25
        )}]`}</Item>
        <Item data={0.5} onClick={addTarget}>{`50%[${Math.ceil(
          totalTradePlanQty * 0.5
        )}]`}</Item>
        <Item data={0.75} onClick={addTarget}>{`75%[${Math.ceil(
          totalTradePlanQty * 0.75
        )}]`}</Item>
      </Submenu>
      <Submenu label="Target + Replace">
        <Item data={0.1} onClick={addTargetAndReplace}>{`10%[${Math.ceil(
          totalTradePlanQty * 0.1
        )}]`}</Item>
        <Item data={0.25} onClick={addTargetAndReplace}>{`25%[${Math.ceil(
          totalTradePlanQty * 0.25
        )}]`}</Item>
        <Item data={0.5} onClick={addTargetAndReplace}>{`50%[${Math.ceil(
          totalTradePlanQty * 0.5
        )}]`}</Item>
        <Item data={0.75} onClick={addTargetAndReplace}>{`75%[${Math.ceil(
          totalTradePlanQty * 0.75
        )}]`}</Item>
      </Submenu>
      <Item onClick={addStop}>Stop</Item>
    </Menu>
  );
});

BidAskContextMenu.propTypes = {
  scaleY: PropTypes.func,
};
